export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var to_load_json_atlas = {
    //"symbols_json": [imgsPath + "symbols/symbols_tp_{q}.png", imgsPath + "symbols/symbols_tp_{q}.info"],
    "symbols_big_json": [imgsPath + "symbols/symbols_tp_big_{q}.png", imgsPath + "symbols/symbols_tp_big_{q}.json"],

    "symbol_Seven_sprite_json": [imgsPath + "symbols/sprites/symbol_Seven_sprite_{q}.png", imgsPath + "symbols/sprites/symbol_Seven_sprite_{q}.json"], //0
    "symbol_Melon_sprite_json": [imgsPath + "symbols/sprites/symbol_Melon_sprite_{q}.png", imgsPath + "symbols/sprites/symbol_Melon_sprite_{q}.json"], //1
    "symbol_Grape_sprite_json": [imgsPath + "symbols/sprites/symbol_Grape_sprite_{q}.png", imgsPath + "symbols/sprites/symbol_Grape_sprite_{q}.json"], //2
    "symbol_Star_sprite_json": [imgsPath + "symbols/sprites/symbol_Star_sprite_{q}.png", imgsPath + "symbols/sprites/symbol_Star_sprite_{q}.json"], //3
    "symbol_Plum_sprite_json": [imgsPath + "symbols/sprites/symbol_Plum_sprite_{q}.png", imgsPath + "symbols/sprites/symbol_Plum_sprite_{q}.json"], //4
    "symbol_Orange_sprite_json": [imgsPath + "symbols/sprites/symbol_Orange_sprite_{q}.png", imgsPath + "symbols/sprites/symbol_Orange_sprite_{q}.json"], //5
    "symbol_Cherry_sprite_json": [imgsPath + "symbols/sprites/symbol_Cherry_sprite_{q}.png", imgsPath + "symbols/sprites/symbol_Cherry_sprite_{q}.json"], //6
    "symbol_Lemon_sprite_json": [imgsPath + "symbols/sprites/symbol_Lemon_sprite_{q}.png", imgsPath + "symbols/sprites/symbol_Lemon_sprite_{q}.json"], //7
    "symbol_Wild_sprite_json": [imgsPath + "symbols/sprites/symbol_Wild_sprite_{q}.png", imgsPath + "symbols/sprites/symbol_Wild_sprite_{q}.json"], //8
    //"symbol_Wild_sprite2_json": [imgsPath + "symbols/sprites/symbol_Wild_sprite2_{q}.png", imgsPath + "symbols/sprites/symbol_Wild_sprite2_{q}.info"],

    /*"symbol_Star_json": [imgsPath + "symbols/symbol_Star_tp_{q}.png", imgsPath + "symbols/symbol_Star_tp_{q}.info"],
    "symbol_Plum_json": [imgsPath + "symbols/symbol_Plum_tp_{q}.png", imgsPath + "symbols/symbol_Plum_tp_{q}.info"],
    "symbol_Orange_json": [imgsPath + "symbols/symbol_Orange_tp_{q}.png", imgsPath + "symbols/symbol_Orange_tp_{q}.info"],
    "symbol_Cherry_json": [imgsPath + "symbols/symbol_Cherry_tp_{q}.png", imgsPath + "symbols/symbol_Cherry_tp_{q}.info"],
    "symbol_Lemon_json": [imgsPath + "symbols/symbol_Lemon_tp_{q}.png", imgsPath + "symbols/symbol_Lemon_tp_{q}.info"],
    "symbol_Wild_json": [imgsPath + "symbols/symbol_Wild_tp_{q}.png", imgsPath + "symbols/symbol_Wild_tp_{q}.info"],*/

    "wingb" : [imgsPath + "winbg_tp_{q}.png", imgsPath + "winbg_tp_{q}.json"],
    "bigwins" : [imgsPath + "bigwin/bigwins3_tp_{q}.png", imgsPath + "bigwin/bigwins3_tp_{q}.json"],
    "boom_spins_json": [imgsPath + "bonus/boom_spins_tp_{q}.png", imgsPath + "bonus/boom_spins_tp_{q}.json"],
    "particles_json": [imgsPath + "particles3_tp_{q}.png", imgsPath + "particles3_tp_{q}.json"],
    //"particles_bigwin_json": [imgsPath + "particles2_tp_bigwin_{q}.png", imgsPath + "particles2_tp_bigwin_{q}.info"],
    //"wild_json": [imgsPath + "wild_tp_{q}.png", imgsPath + "wild_tp_{q}.info"],
    "wild_locked_json": [imgsPath + "symbols/anims/symbol_Wild_locked2_tp_{q}.png", imgsPath + "symbols/anims/symbol_Wild_locked2_tp_{q}.json"],

    "coins_json": [imgsPath + "coins_tp_{q}.png", imgsPath + "coins_tp_{q}.json"]

    /*"symbol_Seven_anim_json": [imgsPath + "symbols/anims/symbol_Seven_tp_{q}.png", imgsPath + "symbols/anims/symbol_Seven_tp_{q}.info"],
    "symbol_Melon_anim_json": [imgsPath + "symbols/anims/symbol_Melon_tp_{q}.png", imgsPath + "symbols/anims/symbol_Melon_tp_{q}.info"],
    "symbol_Grape_anim_json": [imgsPath + "symbols/anims/symbol_Grape_tp_{q}.png", imgsPath + "symbols/anims/symbol_Grape_tp_{q}.info"],
    "symbol_Star_anim_json": [imgsPath + "symbols/anims/symbol_Star_tp_{q}.png", imgsPath + "symbols/anims/symbol_Star_tp_{q}.info"],
    "symbol_Plum_anim_json": [imgsPath + "symbols/anims/symbol_Plum_tp_{q}.png", imgsPath + "symbols/anims/symbol_Plum_tp_{q}.info"],
    "symbol_Orange_anim_json": [imgsPath + "symbols/anims/symbol_Orange_tp_{q}.png", imgsPath + "symbols/anims/symbol_Orange_tp_{q}.info"],
    "symbol_Cherry_anim_json": [imgsPath + "symbols/anims/symbol_Cherry_tp_{q}.png", imgsPath + "symbols/anims/symbol_Cherry_tp_{q}.info"],
    "symbol_Lemon_anim_json": [imgsPath + "symbols/anims/symbol_Lemon_tp_{q}.png", imgsPath + "symbols/anims/symbol_Lemon_tp_{q}.info"],
    "symbol_Wild_anim_json": [imgsPath + "symbols/anims/symbol_Wild_tp_{q}.png", imgsPath + "symbols/anims/symbol_Wild_tp_{q}.info"],*/
};


export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    // 'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    "background"					: imgsPath + "reels/background_{q}.png",
    "background_bonus"				: imgsPath + "reels/background_boom-spins_{q}.png",
    "cover"							: imgsPath + "reels/cover_{q}.png",
    "game_logo"						: imgsPath + "reels/logo_{q}.png",

    "81_left"						: imgsPath + "reels/81_left_{q}.png",
    "81_right"						: imgsPath + "reels/81_right_{q}.png",

    //"win_frame"						: imgsPath + "reels/win_frame_{q}.png",

    "winline_0"						: imgsPath + "winlines/winline1_{q}.png",
    "clock"							: imgsPath + "bonus/clock_background_{q}.png",
    "big_wild"						: imgsPath + "symbol_bigWild_{q}.png",
    "big_wild_bg"					: imgsPath + "symbol_bigWild_bg_{q}.png",
    //"bubbles"						: imgsPath + "symbol",

    "symbol_Seven_big"				: imgsPath + "symbols/big/symbol_Seven_big_{q}.png",
    "symbol_Melon_big"				: imgsPath + "symbols/big/symbol_Melon_big_{q}.png",
    "symbol_Grape_big"				: imgsPath + "symbols/big/symbol_Grape_big_{q}.png",
    "symbol_Star_big"				: imgsPath + "symbols/big/symbol_Star_big_{q}.png",
    "symbol_Plum_big"				: imgsPath + "symbols/big/symbol_Plum_big_{q}.png",
    "symbol_Orange_big"				: imgsPath + "symbols/big/symbol_Orange_big_{q}.png",
    "symbol_Cherry_big"				: imgsPath + "symbols/big/symbol_Cherry_big_{q}.png",
    "symbol_Lemon_big"				: imgsPath + "symbols/big/symbol_Lemon_big_{q}.png",
    "symbol_Wild_big"				: imgsPath + "symbols/big/symbol_Wild_big_{q}.png",

    "wintable"						: imgsPath + "wintable/wintable_{q}.png",
    "infotable"						: imgsPath + "info/info_{q}.png",

    "wild_bg"						: imgsPath + "symbols/symbol_Wild_background_{q}.png",

    "win_frame_left"				: imgsPath + "reels/win_frame_left_{q}.png",
    "win_frame_right"				: imgsPath + "reels/win_frame_right_{q}.png",
    "win_frame_top"					: imgsPath + "reels/win_frame_top_{q}.png",
    "win_frame_bottom"				: imgsPath + "reels/win_frame_bottom_{q}.png",
};

export const to_load_audio = {

    "audio_bonus_bg": audioPath + "bg_BoomSpins.ogg",

    "audio_big_win_explosion": audioPath + "bwin_Explosion.ogg",
    "audio_big_win": audioPath + "bwin_BigWin.ogg",
    "audio_mega_win": audioPath + "bwin_SuperMegaWin_Start.ogg",
    "audio_big_win_end": audioPath + "bwin_SuperMegaWin_End.ogg",

    "reel_spin": audioPath + "reel_Spin.ogg",
    "reel_stop": audioPath + "reel_Stop.ogg",

    "win_low_1": audioPath + "win_Low_1.ogg",
    "win_low_2": audioPath + "win_Low_2.ogg",
    "win_low_3": audioPath + "win_Low_3.ogg",
    "win_low_4": audioPath + "win_Low_4.ogg",
    "win_high_1": audioPath + "win_High_1.ogg",
    "win_high_2": audioPath + "win_High_2.ogg",
    "win_high_3": audioPath + "win_High_3.ogg",
    "win_high_4": audioPath + "win_High_4.ogg",
    "win_stars": audioPath + "win_Stars.ogg",

    //"misc_timer": audioPath + "misc/misc_timer.ogg",

    "symbol_joker": audioPath + "symbol_Joker.ogg",
    "symbol_star": audioPath + "symbol_Star.ogg",

    "bonus_joker": audioPath + "bonus_Joker.ogg",
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",	
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    // 'win_font' :	{
    //     "img":	imgsPath + 'fonts/win_font.png',
    //     "xml":	imgsPath + 'fonts/win_font.xml'
    // },

    "font_bigwins" : {
        'img':	imgsPath + 'fonts/font_bigwins.png',
        'xml':	imgsPath + 'fonts/font_bigwins.xml',
    },

    "font_bigwins_edited" : {
        'img':	imgsPath + 'fonts/font_bigwins_edited.png',
        'xml':	imgsPath + 'fonts/font_bigwins_edited.xml',
    },

    "font_bigwins_second_edited" : {
        'img':	imgsPath + 'fonts/font_bigwins_second.png',
        'xml':	imgsPath + 'fonts/font_bigwins_second_edited.xml',
    },

    "font_freespins" : {
        "img":	imgsPath + "fonts/font_freespins.png",
        "xml":	imgsPath + "fonts/font_freespins.xml",
    },

    "font_wintable" : {
        "img":	imgsPath + "fonts/font_wintable.png",
        "xml":	imgsPath + "fonts/font_wintable.xml",
    }
};

import {madnes_set_audio_volume} from "../../framework/src/engine/madnes/madnes_audio";

export function set_sounds(server_config)
{
    var vol = 1;

    if(typeof server_config["volume"]["bigWin"] !== "undefined") {
        vol = server_config["volume"]["bigWin"];

        madnes_set_audio_volume('audio_big_win_explosion', vol);
        madnes_set_audio_volume('audio_big_win', vol);
        madnes_set_audio_volume('audio_mega_win', vol);
        madnes_set_audio_volume('audio_big_win_end', vol);
    }

    if(typeof server_config["volume"]["buttonEffect"] != "undefined")
    {
        vol = server_config["volume"]["buttonEffect"];

        madnes_set_audio_volume('button_click', vol);
    }

    if(typeof server_config["volume"]["spin"] != "undefined")
    {
        vol = server_config["volume"]["spin"];
        madnes_set_audio_volume('reel_spin', vol);
    }

    if(typeof server_config["volume"]["stopReel"] != "undefined") {

        vol = server_config["volume"]["stopReel"];

        madnes_set_audio_volume('reel_stop', vol);
    }

    if(typeof server_config["volume"]["winAnim"] != "undefined") {

        vol = server_config["volume"]["winAnim"];

        madnes_set_audio_volume('win_low_1', vol);
        madnes_set_audio_volume('win_low_2', vol);
        madnes_set_audio_volume('win_low_3', vol);
        madnes_set_audio_volume('win_low_4', vol);

        madnes_set_audio_volume('win_high_1', vol);
        madnes_set_audio_volume('win_high_2', vol);
        madnes_set_audio_volume('win_high_3', vol);
        madnes_set_audio_volume('win_high_4', vol);

        madnes_set_audio_volume("win_stars", vol);
        //madnes_set_audio_volume("misc_timer", vol);
        madnes_set_audio_volume("bonus_joker", vol);
    }

    if(typeof server_config["volume"]["winCounter"] != "undefined")
    {
        vol = server_config["volume"]["winCounter"];

        madnes_set_audio_volume('remittance_A', vol); //ui_counter.wav
        madnes_set_audio_volume('remittance_B', vol); //ui_counter_stop.wav
    }

    if(typeof server_config["background"]["bonusGameBackground"] != "undefined")
    {
        vol = server_config["background"]["bonusGameBackground"];
        madnes_set_audio_volume('audio_bonus_bg', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds1"] !== "undefined")
    {
        vol = server_config["miscSounds"]["miscSounds1"];

        madnes_set_audio_volume('coins_loop', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds2"] !== "undefined")
    {
        vol = server_config["miscSounds"]["miscSounds2"];

        madnes_set_audio_volume('symbol_joker', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds3"] !== "undefined")
    {
        vol = server_config["miscSounds"]["miscSounds3"];

        madnes_set_audio_volume('symbol_star', vol);
    }
}
